/**
 * Tour — roteiro da VISÃO GERAL. O ÚNICO arquivo que muda pra alterar o que
 * este tutorial diz. Cada passo responde "o que eu faço aqui", em até 2
 * linhas de celular. Pra re-exibir pra todo mundo após uma mudança grande,
 * troque a string de `tela` (ex.: 'visao-geral' → 'visao-geral-v2').
 *
 * v2 (novembro de 2026): tela repaginada — gráfico mensal com projeção,
 * VENDAS DE HOJE em tempo real, relatórios do mês fixos (sem filtro de
 * período) com mapa de calor, e o resumo de 3 meses.
 */
export const TOUR_VISAO_GERAL = {
  tela: "visao-geral-v2",
  titulo: "Visão Geral",
  rota: "/admin/",
  papeis: ["proprietario", "administrador"],
  passos: [
    {
      alvo: "",
      titulo: "Bem-vindo à Visão Geral 👋",
      texto: "Este é o painel de controle da loja. Em 1 minuto te mostro onde olhar todo dia. Toque em qualquer lugar pra avançar.",
    },
    {
      alvo: "vg-mensal",
      titulo: "O ano mês a mês",
      texto: "Faturamento de cada mês, o ano passado tracejado, a média e a projeção até dezembro. Passe o dedo/mouse num mês pra ver os detalhes.",
    },
    {
      alvo: "vg-cards-hoje",
      titulo: "Hoje, em tempo real",
      texto: "Faturamento, pedidos, ticket, preparo, cancelados e IA. Atualiza sozinho a cada minuto e compara com o esperado e o ano passado.",
      raio: 16,
    },
    {
      alvo: "vg-relatorios",
      titulo: "O mês até agora",
      texto: "Pedidos, cancelados e preparo do mês, e o faturamento de cada dia com a projeção até o fim do mês.",
    },
    {
      alvo: "vg-mapa-calor",
      titulo: "Seus horários fortes",
      texto: "Pedidos por hora: verde é pico, vermelho é fraco. O número pequeno é o esperado. Abra o mês inteiro e toque num dia pra ver o faturamento por hora.",
    },
    {
      alvo: "vg-resumo",
      titulo: "Quem move sua loja",
      texto: "Últimos 3 meses: clientes, produtos, formas de pagamento com a taxa paga, módulos, entregadores e categorias.",
    },
    {
      alvo: "",
      titulo: "Pronto! 🚀",
      texto: "Explore sem medo — nada aqui apaga dados. Dúvidas? A aba AJUDA fica no fim do menu, e lá você pode rever este tutorial.",
    },
  ],
};
